import React from "react";
import { Link, Typography } from "@mui/material";

// eslint-disable-next-line
export default {
  title: "Obras",
  programNote: "Nota de programa",
  performanceHistory: "Historial de interpretaciones",
  back: "Anterior",
  next: "Siguiente",
  data: [
    {
      year: "2022",
      name: "El vacío inagotable",
      description: "Ecosistema performático para cuarteto de cuerdas",
      comments: (
        <>
          <Typography variant="caption" sx={{ fontStyle: "italic" }}>
            Comisionado por el{" "}
            <Link
              variant="caption"
              sx={{ fontStyle: "italic" }}
              href="https://jackquartet.com/"
            >
              JACK Quartet
            </Link>{" "}
            a través de su programa JACK Studio
          </Typography>
        </>
      ),
    },
    {
      year: "2022",
      name: "nueva pieza",
      description: "for tres voces masculinas y tres acordeones",
      comments: (
        <>
          <Typography variant="caption" sx={{ fontStyle: "italic" }}>
            Creada para el taller “Composing for Voice and Accordions” de los
            Cursos de Verano de Darmstadt 2021
          </Typography>
        </>
      ),
    },
    {
      year: "2022",
      name: "nueva pieza",
      description: "para guitarra eléctrica, teclado, saxofón y electrónica",
      comments: (
        <>
          <Typography variant="caption" sx={{ fontStyle: "italic" }}>
            Comisionada para{" "}
            <Link
              variant="caption"
              sx={{ fontStyle: "italic" }}
              href="https://soyuz21.ch/en"
            >
              Soyuz21
            </Link>{" "}
            por "ICST – Institute for Computer Music and Sound Technology" en La
            Universidad de las Artes de Zürich como parte de su programa de
            residencias artísticas
          </Typography>
        </>
      ),
    },
    {
      year: "2022",
      name: "nueva pieza",
      description: "para txistu, acordeón y percusión",
      comments: (
        <>
          <Typography variant="caption" sx={{ fontStyle: "italic" }}>
            Comisionada por{" "}
            <Link
              variant="caption"
              sx={{ fontStyle: "italic" }}
              href="https://www.triozukan.com/"
            >
              Trio Zukan
            </Link>
          </Typography>
        </>
      ),
    },
    {
      year: "2022",
      name: "nueva pieza",
      description: "para clarinete bajo, contrabajo y piano",
      comments: (
        <>
          <Typography variant="caption" sx={{ fontStyle: "italic" }}>
            Encargo del Low Frequency Trio a través de su convocatoria Low
            Frequency Oscillator
          </Typography>
        </>
      ),
    },
    {
      year: "2021",
      name: "Camino",
      description:
        "para un intérprete caminando a campo abierto usando una vestimenta sonora",
      comments: (
        <>
          <Typography variant="caption" sx={{ fontStyle: "italic" }}>
            Apoyada por “Ibermúsicas - Ayudas al sector musical en modalidad
            virtual 2020”
          </Typography>
        </>
      ),
    },
    {
      year: "2021",
      name: "Como hilos de viento y luz",
      description:
        "Ecosistema performático para cintas VHS, instrumentos y/o objetos",
      comments: (
        <>
          <Typography variant="caption" sx={{ fontStyle: "italic" }}>
            Compuesta para el Yarn/Wire International Institute 2021
          </Typography>
        </>
      ),
      videos: [
        {
          id: "qZGhUKLgFpY",
          title: "Yarn/Wire",
        },
        {
          id: "jeK3CoYW29Y",
          title: "Kevin Zetina",
        },
        {
          id: "z2tYSfhXopw",
          title: "Yarn/Wire y Jeffrey Gavett",
        },
      ],
    },
    {
      year: "2021",
      name: "La oquedad rugiente",
      description: "para ondas Martenot, bocinas y hojas de papel",
      comments: (
        <>
          <Typography variant="caption" sx={{ fontStyle: "italic" }}>
            Encargo por Alonso Huerta y el sello Discos Carnitas
          </Typography>
        </>
      ),
      audio: [
        {
          url: "https://soundcloud.com/andres_guadarrama/la-oquedad-rugiente-ondes-martenot-speakers-and-paper-sheets-2021e.com",
          text: "Audio",
        },
      ],
    },
    {
      year: "2020",
      name: "En el umbral de la madre inconcebible",
      description:
        "Ecosistema performático para 4 o más intérpretes, 1 tom preparado e instrumentos secundarios, objetos y espacio",
      comments: (
        <>
          <Typography variant="caption" sx={{ fontStyle: "italic" }}>
            Pieza ganadora del 2º premio en el 4º Concurso Nacional de
            Composición para Cuarteto de Percusiones organizado por SAFA
            Ensamble de Percusiones y el CMMAS
          </Typography>
        </>
      ),
      programNote: [
        "De un único instrumento brota un ecosistema sonoro completo. Cada intérprete interactúa de manera parcial con el instrumento, enfocándose exclusivamente en un aspecto del mismo mediante acciones sencillas y restringidas que, sin embargo, tienen un impacto en la totalidad del ecosistema. A través del desarrollo de una sensibilidad, consciencia y cuidado de todas las fuerzas que conforman este ecosistema, el sonido puede manifestar su propia identidad, e invita tanto a los intérpretes y escuchas a reunirse con él y habitarlo.",
      ],
      audio: [
        {
          url: "https://soundcloud.com/andres_guadarrama/en-el-umbral-de-la-madre-inconcebible-maqueta-mockup",
          text: "Audio",
        },
      ],
    },
    {
      year: "2019",
      name: "Lo furioso, lo verdaderamente animal que me sostiene, esto de grito ahorcado como un aullido en la garganta",
      description: "para dos voces y dos flautas de pico",
      comments: (
        <>
          <Typography variant="caption" sx={{ fontStyle: "italic" }}>
            Compuesta para UMS ‘n JIP
          </Typography>
        </>
      ),
      programNote: [
        "Lo furioso, lo verdaderamente animal",
        "que me sostiene, lo que me guarda en pie",
        "con el rencor crecido, esto como de hueso,",
        "como de dientes que me muerden",
        "después de haber mascado el polvo,",
        "esto de sangre, esto de grito ahorcado",
        "como un aullido en la garganta,",
        "esto como un muro, como un sollozo",
        "largo de noche sin hogueras, lo animal,",
        "lo verdaderamente bronco que me duele en los ojos.",
        "Max Rojas, El turno del aullante",
      ],
      performanceHistory: [
        "04.03.2019. UMS ’n JIP. The Latinoamerica Project. Kunstraum Walcheturm. Zürich, Suiza ",
        "03.03.2019. UMS ’n JIP. The Latinoamerica Project. Zeughaus Kultur. Brig-Glis, Suiza",
        "01.03.2019. UMS ’n JIP. The Latinoamerica Project. Unternehmen Mitte. Berna, Suiza",
        "28.02.2019. UMS ’n JIP. World Premiere. The Latinoamerica Project. Ono. Bern, Suiza",
      ],
    },
    {
      year: "2018",
      name: "La quemadura es el lenguaje con que juro, manos abiertas sobre el hielo",
      description: "para 2 intérpretes y 1 bajo eléctrico",
      comments: (
        <>
          <Typography variant="caption" sx={{ fontStyle: "italic" }}>
            Compuesta con el apoyo de la beca FONCA Jóvenes Creadores 2017-2018
          </Typography>
        </>
      ),
      programNote: [
        "Dos intérpretes actúan conjuntamente para ofrecer una idea, un flujo sonoro, tan irregular, delicado y hasta cierto punto incontrolable, como jugar con fuego o pintar en el agua. Los múltiples sonidos que fluyen del bajo son consecuencia de acciones limitadas y frágiles que requieren una gran cantidad de concentración y comunicación por parte de los intérpretes. El título de esta pieza es un poema del escritor mexicano Julian Herbert. Esta pieza fue compuesta con el apoyo del Programa Jóvenes Creadores 2017-2018 del FONCA.",
      ],
      performanceHistory: [
        "04.03.2019. UMS ’n JIP. The Latinoamerica Project. Kunstraum Walcheturm. Zürich, Suiza ",
        "03.03.2019. UMS ’n JIP. The Latinoamerica Project. Zeughaus Kultur. Brig-Glis, Suiza",
        "01.03.2019. UMS ’n JIP. The Latinoamerica Project. Unternehmen Mitte. Berna, Suiza",
        "28.02.2019. UMS ’n JIP. World Premiere. The Latinoamerica Project. Ono. Bern, Suiza",
      ],
      videos: [
        {
          id: "CMNa2wwlouU",
          title: "Xin, primera versión",
        },
        {
          id: "w1hdQ1f-xg4",
          title: "Xin, segunda versión",
        },
      ],
      audio: [
        {
          url: "https://soundcloud.com/andres_guadarrama/la-quemadura-es-el-lenguaje-con-que-juro-manos-abiertas-sobre-el-hielo-2018",
          text: "Audio",
        },
      ],
    },
    {
      year: "2017",
      name: "Hand Shadows",
      description: "para acordeón",
      comments: (
        <>
          <Typography variant="caption" sx={{ fontStyle: "italic" }}>
            Compuesta para Eva Zöllner como parte de su proyecto “Caja de
            Viento” llevado a cabo durante el año dual México-Alemania
          </Typography>
        </>
      ),
      videos: [
        {
          id: "nnbGc6Xq9y0",
          title: "Hand Shadows I",
        },
        {
          id: "LawgDknFprk",
          title: "Hand Shadows II",
        },
      ],
      programNote: [
        "Las dos miniaturas que conforman esta obra están inspiradas en los juegos en los que las sombras de las manos se proyectan en una superficie para formar diferentes figuras. El acordeón es un instrumento muy sensible cuya sonoridad se modifica como resultado de cualquier movimiento, por diminuto que sea, del cuerpo del interprete. En ambas miniaturas se construyen figuras delicadas que son sujetas a una constante transformación en la que adquieren un papel primordial la inventiva, características fisiológicas particulares del intérprete, modelo específico de acordeón y el espacio acústico en el que se interpreten, de manera que la percepción de estas figuras sea diferente en cada presentación de acuerdo a la superficie” en la que se proyecten.",
      ],
      performanceHistory: [
        "08.04.2017. Eva Zöllner. Estreno Absoluto. Caja de Viento. Museo de Arte de la SHCP-Antiguo Palacio del Arzobispado, Ciudad de México, México",
      ],
    },
    {
      year: "2016",
      name: "Colotomy",
      description: "para piano",
      comments: (
        <>
          <Typography variant="caption" sx={{ fontStyle: "italic" }}>
            Compuesta para Ignacio Torner durante el Ciclo Laberintos Sonoros
          </Typography>
        </>
      ),
      audio: [
        {
          url: "https://soundcloud.com/andres_guadarrama/colotomy-piano-2016",
          text: "Audio",
        },
      ],
      performanceHistory: [
        "18.10.2019. Joseph Houston. Donaueschinger Musiktage 2019. Donaueschingen, Alemania",
        "23.08.2018. Pablo Miró Cortez. XL Foro Internacional de Música Nueva Manuel Enríquez. Museo Nacional de Arte, Ciudad de México, México",
        "23.04.2018. Ignacio Torner. Jornadas de Música Contemporánea del Círculo Colombiano de Música Contemporánea. Fundación Gilberto Alzate Avendaño, Bogotá, Colombia",
        "02.12.2017. Ignacio Torner. Estreno absoluto. Festival Encuentros Sonoros ’17. Sala Joaquín Turina, Sevilla, España",
      ],
      programNote: [
        "El término Colotomy fue creado por el etnomusicólogo holandés Jaap Kunst para refe-rirse a la relación entre estructura, densidad, tempo, y función instrumental dentro de una composición tradicional de gamelan. El ataque inicial establece las relaciones a partir de las cuales están organizados los diferentes planos rítmicos del piano y la manera en cómo se desdoblan a lo largo de la pieza es producto de una interpretación personal de este concepto de la música tradicional de Indonesia. Esta pieza fue realizada para el Seminario de Composición Laberintos Sonoros, a cargo de Javier Torres Maldonado y está dedicada a Ignacio Torner, pianista del En-samble Taller Sonoro.",
      ],
    },
    {
      year: "2016",
      name: "Dial-Up",
      description: "para saxofón alto y electrónica",
      comments: (
        <>
          <Typography variant="caption" sx={{ fontStyle: "italic" }}>
            Compuesta para Boglárka Nagy
          </Typography>
        </>
      ),
      audio: [
        {
          url: "https://soundcloud.com/andres_guadarrama/dial-up-alto-sax-and-electronics",
          text: "Audio",
        },
      ],
      programNote: [
        "Those who discovered the Internet in the late 90s nostalgically recall the sound produced when the connection started. The telephone plug, originally designed to transmit the human voice, was taken by a pair of modems that conversed in “zeros and ones” to establish protocols that allow a successful connection. The work started with a spectral analysis of the dial-up sound. The saxophone dialogues with the electronics in the same way a modem did it with another. Dial-up is a meditation on how this sound has become a testimony of the connection between the analogue and digital worlds; which have slowly erased its frontiers over time, establishing irrevocably as one.",
      ],
      performanceHistory: [
        "18.11.2016. Boglárka Nagy. Fundación Sebastián, Ciudad de México, México",
        "28.10.2016. Boglárka Nagy. Fonometrías. CMMAS, Morelia, México",
        "24.08.2016. Boglárka Nagy. Estreno absoluto. Fonometrías. Sala Carlos Chávez, CCU-UNAM. Ciudad de México, México",
      ],
    },
    {
      year: "2016",
      name: "If everything returns to the one, where does the one return to?",
      description: "para violín solo",
      comments: (
        <>
          <Typography variant="caption" sx={{ fontStyle: "italic" }}>
            Compuesta para Irvine Arditti
          </Typography>
        </>
      ),
      audio: [
        {
          url: "https://soundcloud.com/andres_guadarrama/if-everything-return-to-the-one-where-does-the-one-return-to",
          text: "Audio",
        },
      ],
      performanceHistory: [
        "20.03.2016. Irvine Arditti. CIEM, Ciudad de México, México",
      ],
    },
    {
      year: "2015",
      name: "Yugen",
      description: "para 1 vibráfono y 4 intérpretes",
      comments: (
        <>
          <Typography variant="caption" sx={{ fontStyle: "italic" }}>
            Compuesta para Tambuco durante el Taller de Composición para
            Cuarteto de Percusiones en el Núcleo Integral de Composición (NICO)
          </Typography>
          <Typography variant="caption" sx={{ fontStyle: "italic" }}>
            Pieza recomendada en la 63va Tribuna Internacional de Compositores
            de la UNESCO en Wrocław, Polonia
          </Typography>
        </>
      ),
      audio: [
        {
          url: "https://soundcloud.com/andres_guadarrama/yugen-2015",
          text: "Audio",
        },
      ],
      programNote: [
        '"Lo mismo que una piedra fosforescente en la oscuridad pierde toda su fascinante sensación de joya preciosa si es expuesta a plena luz, la belleza pierde toda su existencia si se suprimen los efectos de la sombra."',
        "Junichiro Tanizaki, El Elogio de la sombra.",
        "La luminosidad del vibráfono viaja a través de un juego de claroscuros; texturas delicadas y etéreas forman un velo que, como el humo en el aire, se desvanece en un suspiro. Una serie de fuertes ataques rítmicos terminan degradados en toques minúsculos apenas audibles, como grandes formaciones rocosas que se convierten en brillantes y pulidas piedras de río.",
        "Yugen es la apreciación de la belleza imperfecta, efímera e incompleta. Aquella que reposa, con misteriosa gracia y melancolía, en las profundidades de la sombra y en los rastros que deja el inevitable paso del tiempo.",
      ],
      performanceHistory: [
        "16.11.2017. Tambuco. Tambuco Japan Tour 2017. Tokyo, Japón",
        "01.08.2016. Tambuco. Estreno absoluto. Sala Blas Galindo del Centro Nacional de la Artes, Ciudad de México, México",
      ],
    },
  ],
};
